<template>
  <el-dialog 
    title="输入作业内容" 
    :visible.sync="dialogVisible" 
    width="350px" 
    :close-on-click-modal="false" 
    @opened="focusHomeworkContent" 
    :append-to-body="true" 
    :class="dialogClass">
    <el-input
        placeholder="请输入作业内容"
        v-model="inputContent"
        ref="homeworkContentInput"
        style="width: 300px;"
        :maxlength="200"
        @keyup.enter.native="handleEnterKey">
    </el-input>
    <span slot="footer" class="dialog-footer">
        <el-button @click="$emit('close')">取 消</el-button>
        <el-button type="primary" @click="handleSave">{{ confirmButtonText }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'HomeworkContentDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'default', // 'default' 或 'management'
      validator: value => ['default', 'management'].includes(value)
    },
    isAssigned: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      inputContent: ''
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    dialogClass() {
      return this.theme === 'management' ? 'homework-content-dialog management-theme' : 'homework-content-dialog'
    },
    confirmButtonText() {
      return '保 存'
    }
  },
  watch: {
    content(newVal) {
      this.inputContent = newVal
    },
    visible(newVal) {
      if (newVal) {
        this.inputContent = this.content
      }
    }
  },
  methods: {
    focusHomeworkContent() {
      // 在弹窗打开后聚焦到文本输入框
      this.$nextTick(() => {
        if (this.$refs.homeworkContentInput) {
          this.$refs.homeworkContentInput.focus()
        }
      })
    },
    handleEnterKey() {
      this.handleSave()
    },
    handleSave() {
      this.$emit('save', this.inputContent)
    }
  }
}
</script>

<style scoped>
/* 作业内容弹窗基础样式 */
.homework-content-dialog ::v-deep .el-dialog {
  border-radius: 10px !important;
  overflow: hidden;
}

.homework-content-dialog ::v-deep .el-dialog__footer {
  background-color: white !important;
}

/* 管理界面主题样式 */
.homework-content-dialog.management-theme ::v-deep .el-dialog__header {
  background: #6abfd1 !important;
  border-radius: 10px 10px 0 0 !important;
}

.homework-content-dialog.management-theme ::v-deep .el-button--primary:not(:disabled) {
  background: linear-gradient(90deg, #6abfd1, #6abfd1) !important;
  border: none !important;
  color: white !important;
}

.homework-content-dialog.management-theme ::v-deep .el-button--primary:not(:disabled):hover {
  background: linear-gradient(90deg, #5d8aa8, #4682b4) !important;
  border: none !important;
  color: white !important;
  transform: scale(1.05);
  transition: all 0.2s ease;
}
</style>